import {
  PartnerVerificationFormValues,
  PartnerVerificationFormViolation,
} from 'types/state';

export const validatePartnerVerificationFormValues = (
  values: PartnerVerificationFormValues
): PartnerVerificationFormViolation[] => {
  const violations: PartnerVerificationFormViolation[] = [];

  const { codeChars } = values;

  for (let [charIndex, charValue] of Array.from(codeChars.entries())) {
    if (charValue === '') {
      violations.push({
        name: 'CharMissed',
        charIndex,
      });
    }
  }

  return violations;
};
